<template>
  <div @mousewheel="mousewheel">
    <!-- <div class="point" v-if="ponitShow" @mouseleave="handlerMouseover"> -->
    <div class="point" v-show="isShow1" @mouseleave="mouseleave">
      <div>
        <div
          :class="{ 'active-scroll': code == index }"
          @click="handlerClickId(item)"
          v-for="(item, index) in pointList"
          :key="item.code"
          style="cursor: pointer"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="nav_box">
      <div class="spaceline"></div>
      <div id="sszmqBox">
        <div class="m-wrapper" style="border-radius: 0px; box-shadow: none">
          <div class="titleBox">
            <span class="bigTitleInfo">Provincial/Municipal FTZs</span>
          </div>
          <div class="clearfix" style="position: relative; top: -40px">
            <div style="float: right; margin-right: 35px">
              <div class="form" style="float: left">
                <el-select
                  filterable
                  popper-class="select-down"
                  size="small"
                  v-model="province"
                  placeholder="select"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                style="float: left; margin-left: 20px"
                @click="handleClick"
                class="confirm-button"
              >
                Go
              </div>
              <div
                v-if="this.downloadButton"
                style="float: left; margin-left: 20px"
                @click="downloadReport"
                class="confirm-button"
              >
                Download Report
              </div>
            </div>
          </div>

          <div class="map-wrapper" style="top: -40px">
            <div class="map-content">
              <div style="height: 481px; background: #ddd">
                <div class="mapDiv" v-loading="loading">
                  <FtaInfoMap
                    :center="center"
                    :zoom="zoom"
                    :path="path"
                    :cityListArr="cityListArr"
                    :showCity="showCity"
                    :icon="icon"
                    :province="province"
                    :proName="proName"
                  />
                </div>
              </div>
            </div>
            <div class="map-info">
              <div class="item">
                <div id="jbjjBox">
                  <span class="globalInfo">FTZ Profile</span>
                </div>
                <div style="height: 83px; background-color: #fff" class="p15">
                  <vue-scroll :ops="scrollOption">
                    <div class="map-detail-1">
                      <div
                        v-for="(item, index) in infoIntroduction"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </vue-scroll>
                </div>
              </div>
              <div class="item">
                <div id="zldwBox">
                  <span class="globalInfo">Strategic Positioning</span>
                </div>
                <div style="height: 83px; background-color: #fff" class="p15">
                  <vue-scroll :ops="scrollOption">
                    <div class="map-detail-2">
                      <div>{{ info.strategicOrientation }}</div>
                    </div>
                  </vue-scroll>
                </div>
              </div>
              <div class="item">
                <div id="zdcyBox">
                  <span class="globalInfo">Key Industry</span>
                </div>
                <div style="height: 83px; background-color: #fff" class="p15">
                  <vue-scroll :ops="scrollOption">
                    <div class="detail-3">
                      <div style="width: 100%">
                        <div
                          class="item"
                          :key="index"
                          v-for="(item, index) in info.indsStrategy"
                          style="width: 100%"
                        >
                          <img
                            style="margin-right: 13px"
                            width="15"
                            height="16"
                            :src="iconPath"
                            alt=""
                          />
                          <span>{{ item }}</span>
                        </div>
                      </div>
                    </div>

                    <!--                <div class="map-detail-3 p15">-->
                    <!--                  <div class="ti-2em">{{ info.indsStrategy }}</div>-->
                    <!--                </div>-->
                  </vue-scroll>
                </div>
              </div>
              <div class="item">
                <div id="gljgBox">
                  <span class="globalInfo">Administration</span>
                </div>
                <div style="height: 83px; background-color: #fff" class="p15">
                  <vue-scroll :ops="scrollOption">
                    <div>
                      <div
                        class="item"
                        v-for="(item, index) in info.manageOrg"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </vue-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav_box">
      <div class="spaceline"></div>
      <div class="m-wrapper">
        <div class="titleBox">
          <span class="bigTitleInfo">Industrial Structure</span>
          <span>Statistics in {{ structureLut.year }}</span>
        </div>
        <div class="splitLine"></div>
        <div class="gird-wrapper">
          <div class="left">
            <div class="pie-top clearfix">
              <div class="title">{{ info.ftzPrc }} Economic Structure</div>
              <div class="unit">Unit: billion CNY</div>
            </div>
            <div id="box">
              <FtaInfoPie
                :color="['#FCA900', '#313CFF', '#477FFF']"
                :type="2"
                :position="1"
                :width="'100%'"
                :height="'290px'"
                :unit="'billion CNY'"
                :id="'pie7'"
                :keyName="'label'"
                :keyCount="'value'"
                :option="structureList"
              />
            </div>
          </div>
          <!--        <div class="left" v-else  style="display: flex;justify-content: center;align-items: center">No Data</div>-->

          <div class="right" v-if="ftaGroupInfoList.length !== 0">
            <div class="title">Key Companies in {{ norm.ftzName }}</div>
            <div class="list">
              <div style="height: 268px">
                <vue-scroll :ops="scrollOption">
                  <div class="list-wrapper">
                    <div
                      v-for="(item, index) in ftaGroupInfoList"
                      :key="index"
                      :class="['item', item.close ? '' : 'item-active']"
                      @click="item.close = !item.close"
                    >
                      <div class="list-wrapper-item-box">
                        <div class="top clearfix">
                          <div class="title">{{ item.name }}</div>
                          <div class="tips clearfix">
                            <div class="item" v-if="item.type">
                              {{ item.type }}
                            </div>
                            <div class="item" v-if="item.industry">
                              {{ item.industry }}
                            </div>
                            <div class="item" v-if="item.openingStatus">
                              {{ item.openingStatus }}
                            </div>
                          </div>
                        </div>
                        <div class="info clearfix">
                          <div class="item">
                            <span>Legal representative：</span>
                            <span v-if="item.legalPerson">{{
                              item.legalPerson
                            }}</span>
                            <span v-else>No Data</span>
                          </div>
                          <div class="item">
                            <span>Registered capital：</span>
                            <span v-if="item.registeredCapital">{{
                              item.registeredCapital
                            }}</span>
                            <span v-else>No Data</span>
                          </div>
                        </div>
                        <div class="info clearfix">
                          <div class="item">
                            <span>Address：</span>
                            <span v-if="item.address">{{ item.address }}</span>
                            <span v-else>No Data</span>
                          </div>
                          <div class="item">
                            <span>Date：</span>
                            <span v-if="item.establishTime">{{
                              item.establishTime
                            }}</span>
                            <span v-else>No Data</span>
                          </div>
                        </div>
                        <div class="text">
                          <span>Business scope：</span>
                          <span v-if="item.businessScope">{{
                            item.businessScope
                          }}</span>
                          <span v-else>No Data</span>
                        </div>
                      </div>
                      <div class="icon">
                        <img :src="closeIcon" alt="" v-if="item.close" />
                        <img :src="openIcon" alt="" v-else />
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <div
            class="right"
            v-else
            style="display: flex; justify-content: center; align-items: center"
          >
            No Data
          </div>
        </div>
      </div>
      <div class="splitLine"></div>
      <!-- <FtaBottomDateInfo :info="'Data statistic circle of industry distribution'" :date="structureLut" /> -->
    </div>

    <div class="nav_box" v-if="calculation">
      <div id="jjyxBox">
        <div class="titleBox">
          <span class="bigTitleInfo">Economic Operation</span>
          <span class="chenge-dir"
            >Statistics in {{ percentageLut.year }}<br />The following data is
            for reference only</span
          >
        </div>
        <div class="splitLine"></div>

        <div
          class="new-m-wrapper"
          style="border-radius: 0; box-shadow: none"
          v-if="false"
        >
          <div class="jjyxfx-top">
            <div class="new-item">
              <div
                class="new-title"
                :title="`${norm.ftzName} Total New Foreign Companies`"
              >
                {{ norm.ftzName }} Total New Foreign Companies
              </div>
              <div class="new-info" v-if="norm.newEntCount">
                <span class="value">{{ norm.newEntCount }}</span>
                <span class="unit"></span>
              </div>
              <NoDataText
                style="margin-top: 17px"
                v-if="!norm.newEntCount"
                :fontColor="'#fff'"
              />
            </div>
            <div class="new-item">
              <div class="new-title" :title="`${norm.ftzName} Total FDI`">
                {{ norm.ftzName }} Total FDI
              </div>
              <div class="new-info" v-if="norm.fgnInvest">
                <span class="value">{{ norm.fgnInvest }}</span>
                <span class="unit">billion USD</span>
              </div>
              <NoDataText
                style="margin-top: 17px"
                v-if="!norm.fgnInvest"
                :fontColor="'#fff'"
              />
            </div>
            <div class="new-item">
              <div
                class="new-title"
                :title="`${norm.ftzName} Total Import&Export`"
              >
                {{ norm.ftzName }} Total Import&Export
              </div>
              <div class="new-info" v-if="norm.tmx">
                <span class="value">{{ norm.tmx }}</span>
                <span class="unit"> billion CNY</span>
              </div>
              <NoDataText
                style="margin-top: 17px"
                v-if="!norm.tmx"
                :fontColor="'#fff'"
              />
            </div>
            <div class="new-item">
              <div
                class="new-title"
                :title="`${norm.ftzName} Total Tax Revenue`"
              >
                {{ norm.ftzName }} Total Tax Revenue
              </div>
              <div class="new-info" v-if="norm.tax">
                <span class="value">{{ norm.tax }}</span>
                <span class="unit">billion CNY</span>
              </div>
              <NoDataText
                style="margin-top: 17px"
                v-if="!norm.tax"
                :fontColor="'#fff'"
              />
            </div>
            <div class="new-item">
              <div
                class="new-title"
                :title="`${norm.ftzName} Total Registered Capitals Of New Companies`"
              >
                {{ norm.ftzName }} Total Registered Capitals Of New Companies
              </div>
              <div class="new-info" v-if="norm.registCapital">
                <span class="value">{{ norm.registCapital }}</span>
                <span class="unit">billion CNY</span>
              </div>
              <NoDataText
                style="margin-top: 17px"
                v-if="!norm.registCapital"
                :fontColor="'#fff'"
              />
            </div>
          </div>
        </div>
        <fta-info-tap
          @changeNewecomic="changeNewecomic"
          :NEWeconomicsDisplay="NEWeconomicsDisplay"
          :taxList="taxList"
          :fgnInvestList="fgnInvestList"
          :newEntCountList="newEntCountList"
          :tmxList="tmxList"
          :info="info"
        />

        <div class="chart_" :class="{ chart_tow: jcentont }">
          <div class="chart_1" v-if="dataYear.tmxTotalYear">
            <div
              class="chartTitle1"
              :title="`Propotion of ${norm.ftzName} Import&Export among all FTZs`"
            >
              <p>
                Propotion of {{ norm.ftzName }} Import&Export among all FTZs
              </p>
            </div>
            <div>
              <div class="chart-text">
                <span class="chart-text-rl">{{ dataYear.tmxTotalYear }}</span>
              </div>
              <div id="box1">
                <FtaInfoPie
                  :color="['#fba800', '#cbcbcb']"
                  :type="1"
                  :position="1"
                  :width="'100%'"
                  :height="'285px'"
                  :id="'pie1'"
                  :keyName="'name'"
                  :keyCount="'value'"
                  :option="pie1"
                  :unit="'(billion CNY)'"
                />
              </div>
            </div>
          </div>
          <div class="chart_2" v-if="dataYear.taxTotalYear">
            <div
              class="chartTitle2"
              :title="`Propotion of ${norm.ftzName} Tax Revenue among all FTZs`"
            >
              <p>Propotion of {{ norm.ftzName }} Tax Revenue among all FTZs</p>
            </div>
            <div>
              <div class="chart-text">
                <span class="chart-text-rl">{{ dataYear.taxTotalYear }}</span>
              </div>
              <div id="box2">
                <FtaInfoPie
                  :color="['#fba800', '#cbcbcb']"
                  :position-type="1"
                  :width="'100%'"
                  :height="'285px'"
                  :id="'pie2'"
                  :keyName="'name'"
                  :keyCount="'value'"
                  :option="pie2"
                  :unit="'(billion CNY)'"
                />
              </div>
            </div>
          </div>
          <div class="chart_3" v-if="dataYear.fgnInvestTotalYear">
            <div
              class="chartTitle3"
              :title="`Propotion of ${norm.ftzName} FDI among all FTZs`"
            >
              <p>Propotion of {{ norm.ftzName }} FDI among all FTZs</p>
            </div>
            <div>
              <div class="chart-text">
                <span class="chart-text-rl">{{
                  dataYear.fgnInvestTotalYear
                }}</span>
              </div>
              <div id="box3">
                <FtaInfoPie
                  :color="['#fba800', '#cbcbcb']"
                  :position-type="1"
                  :width="'100%'"
                  :height="'285px'"
                  :id="'pie3'"
                  :keyName="'name'"
                  :keyCount="'value'"
                  :option="pie3"
                  :unit="'(billion USD)'"
                />
              </div>
            </div>
          </div>
          <div class="chart_1" v-if="dataYear.tmxPrcYear">
            <div
              class="chartTitle1"
              :title="`Propotion of ${norm.ftzName} Import&Export among ${
                info.ftzPrc
              } ${
                ['Shanghai', 'Beijing', 'Tianjing', 'Chongqing'].includes(
                  info.ftzPrc
                )
                  ? 'municipality'
                  : 'province'
              }`"
            >
              <p>
                Propotion of {{ norm.ftzName }} Import&Export among
                {{ info.ftzPrc }}
                {{
                  ["Shanghai", "Beijing", "Tianjing", "Chongqing"].includes(
                    info.ftzPrc
                  )
                    ? "municipality"
                    : "province"
                }}
              </p>
            </div>
            <div>
              <div class="chart-text">
                <span class="chart-text-lf"
                  >* Exchange rate: 1 USD= 6.5 CNY</span
                >
                <span class="chart-text-rl">{{ dataYear.tmxPrcYear }}</span>
              </div>
              <div id="box4">
                <FtaInfoPie
                  :color="['#477FFF', '#cbcbcb']"
                  :position-type="1"
                  :width="'100%'"
                  :height="'285px'"
                  :id="'pie4'"
                  :keyName="'name'"
                  :keyCount="'value'"
                  :option="pie4"
                  :unit="'(billion CNY)'"
                  :totalText="'Total'"
                />
              </div>
            </div>
          </div>
          <div class="chart_2" v-if="dataYear.taxPrcYear">
            <div
              class="chartTitle2"
              :title="`Propotion of ${norm.ftzName} Tax Revenue among ${
                info.ftzPrc
              } ${
                ['Shanghai', 'Beijing', 'Tianjing', 'Chongqing'].includes(
                  info.ftzPrc
                )
                  ? 'municipality'
                  : 'province'
              }`"
            >
              <p>
                Propotion of {{ norm.ftzName }} Tax Revenue among
                {{ info.ftzPrc }}
                {{
                  ["Shanghai", "Beijing", "Tianjing", "Chongqing"].includes(
                    info.ftzPrc
                  )
                    ? "municipality"
                    : "province"
                }}
              </p>
            </div>
            <div>
              <div class="chart-text">
                <span class="chart-text-rl">{{ dataYear.taxPrcYear }}</span>
              </div>
              <div id="box5">
                <FtaInfoPie
                  :color="['#477FFF', '#cbcbcb']"
                  :position-type="1"
                  :width="'100%'"
                  :height="'285px'"
                  :id="'pie5'"
                  :keyName="'name'"
                  :keyCount="'value'"
                  :option="pie5"
                  :unit="'(billion CNY)'"
                  :totalText="'Total'"
                />
              </div>
            </div>
          </div>
          <div class="chart_3" v-if="dataYear.fgnInvestPrcYear">
            <div
              class="chartTitle3"
              :title="`Propotion of ${norm.ftzName} FDI among ${info.ftzPrc} ${
                ['Shanghai', 'Beijing', 'Tianjing', 'Chongqing'].includes(
                  info.ftzPrc
                )
                  ? 'municipality'
                  : 'province'
              }`"
            >
              <p>
                Propotion of {{ norm.ftzName }} FDI among {{ info.ftzPrc }}
                {{
                  ["Shanghai", "Beijing", "Tianjing", "Chongqing"].includes(
                    info.ftzPrc
                  )
                    ? "municipality"
                    : "province"
                }}
              </p>
            </div>
            <div>
              <div class="chart-text">
                <span class="chart-text-rl">{{
                  dataYear.fgnInvestPrcYear
                }}</span>
              </div>
              <div id="box6">
                <FtaInfoPie
                  :color="['#477FFF', '#cbcbcb']"
                  :position-type="1"
                  :width="'100%'"
                  :height="'285px'"
                  :id="'pie6'"
                  :keyName="'name'"
                  :keyCount="'value'"
                  :option="pie6"
                  :unit="'(billion USD)'"
                  :totalText="'Total'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="splitLine"></div>
      <!-- <FtaBottomDateInfo :info="'Data statistic circle of economic operation'" :date="percentageLut" /> -->
    </div>

    <div class="nav_box" v-if="false">
      <div id="jjfzqsBigBox">
        <div class="titleBox">
          <span class="bigTitleInfo">Economic Development</span>
          <span class="chenge-dir"
            >The following data is for reference only</span
          >
        </div>
        <div class="splitLine"></div>

        <!-- <div class="economics">
      <div class="jjfzqsBox">
          <div class="jjfzqsTitleBox1" title="FTZ Tax Revenue"><span class="jjfzqsTitle">FTZ Tax Revenue</span></div>
          <div class="jjfzqsUnit">Unit: billion CNY</div>
              <FtaInfoLine
                :title="'FTZ Tax Revenue'"
                :height="'308px'"
                :id="'line1'"
                :color="'#437BFF'"
                :option="taxList"
                :unit="'billion CNY'"
              />
      </div>
      <div class="jjfzqsBox">
          <div class="jjfzqsTitleBox2" title="FTZ FDI"><span class="jjfzqsTitle">FTZ FDI</span></div>
          <div class="jjfzqsUnit"></div>
              <FtaInfoLine
                :title="'FTZ FDI'"
                :height="'308px'"
                :id="'line2'"
                :color="'#FFBA46'"
                :option="newEntCountList"
                :unit="''"
              />
      </div>
    </div>

    <div class="economics">
      <div class="jjfzqsBox">
          <div class="jjfzqsTitleBox1" title="FTZ New Foreign Company"><span class="jjfzqsTitle">FTZ New Foreign Company</span></div>
          <div class="jjfzqsUnit">Unit: billion USD</div>
              <FtaInfoLine
                :title="'FTZ New Foreign Company'"
                :height="'308px'"
                :id="'line3'"
                :color="'#5AD55B'"
                :option="fgnInvestList"
                :unit="'billion USD'"
              />
      </div>
      <div class="jjfzqsBox">
          <div class="jjfzqsTitleBox2" title="FTZ Import&Export"><span class="jjfzqsTitle">FTZ Import&Export</span></div>
          <div class="jjfzqsUnit">Unit: billion CNY</div>
              <FtaInfoLine
                :title="'FTZ Import&Export'"
                :height="'308px'"
                :id="'line4'"
                :color="'#EFA9BD'"
                :option="tmxList"
                :unit="'billion CNY'"
              />
      </div>
    </div> -->
        <fta-info-tap
          @changeNewecomic="changeNewecomic"
          :NEWeconomicsDisplay="NEWeconomicsDisplay"
          :taxList="taxList"
          :fgnInvestList="fgnInvestList"
          :newEntCountList="newEntCountList"
          :tmxList="tmxList"
          :info="info"
        />
      </div>
      <div class="splitLine"></div>
      <!-- <FtaBottomDateInfo :info="'Economic growth trend data until'" :date="trendLut" /> -->
    </div>

    <div class="nav_box">
      <div class="m-wrapper" style="border-radius: 0px">
        <div class="titleBox">
          <span class="bigTitleInfo">Investment Cost</span>
          <span>Statistics in {{ workLut.year }}</span>
        </div>
        <div class="splitLine" style="margin-bottom: 0"></div>
        <div class="new-gird-wrapper">
          <div class="new-gird-item">
            <div class="new-gird-icon"><img :src="waterIcon" alt="" /></div>
            <div class="new-gird-info">
              <div class="new-gird-title">
                {{ norm.ftzName }} Commercial Water Fee
              </div>
              <div class="new-gird-value" v-if="work.comWaterCharge">
                <span class="new-gird-s">{{
                  parseFloat(work.comWaterCharge)
                }}</span>
                <span class="new-gird-unt">CNY/m³</span>
              </div>
              <NoDataText
                style="margin-top: 10px"
                :fontColor="'#fff'"
                v-if="!work.comWaterCharge"
              />
            </div>
          </div>
          <div class="new-gird-item">
            <div class="new-gird-icon"><img :src="electricIcon" alt="" /></div>
            <div class="new-gird-info">
              <div class="new-gird-title">
                {{ norm.ftzName }} Commercial Electricity Fee
              </div>
              <div class="new-gird-value" v-if="work.comElecCharge">
                <span class="new-gird-s">{{
                  parseFloat(work.comElecCharge)
                }}</span>
                <span class="new-gird-unt">CNY/kw·h</span>
              </div>
              <NoDataText
                style="margin-top: 10px"
                :fontColor="'#fff'"
                v-if="!work.comElecCharge"
              />
            </div>
          </div>
          <div class="new-gird-item">
            <div class="new-gird-icon"><img :src="iconPathIcon" alt="" /></div>
            <div class="new-gird-info">
              <div class="new-gird-title">
                {{ norm.ftzName }} Average Labor Cost
              </div>
              <div class="new-gird-value" v-if="work.laborCost">
                <span class="new-gird-s">{{ parseFloat(work.laborCost) }}</span>
                <span class="new-gird-unt">CNY/year</span>
              </div>
              <NoDataText
                style="margin-top: 10px"
                :fontColor="'#fff'"
                v-if="!work.laborCost"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="splitLine"></div>
      <!-- <FtaBottomDateInfo
      :info="'Investment decision data until'"
      :date="workLut"
    ></FtaBottomDateInfo> -->
    </div>
    <div class="nav_box" id="zmqzxzsBox">
      <div class="m-wrapper" style="border-radius: 0px">
        <div class="titleBox">
          <span class="bigTitleInfo">FTZ News</span>
        </div>
        <div class="splitLine"></div>
        <div class="news-list-wrapper" style="padding-bottom: 27px">
          <FtaTable
            ref="newsTable"
            :tableData="newsList"
            :column="newsColumn"
            :scrollStar="newsScrollFlag"
            :diaLogShow="true"
            :isIndex="false"
            :pageable="true"
            :pageConfig="pageConfig"
            @pageConfigs="changePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import geoJson from "@/ftaUtils/china.js";
import cityCenter from "@/ftaUtils/city.js";
import geoJsons from "@/ftaUtils/geojsons.js";
import html2canvas from "html2canvas";
import FtaHeader from "../component/FtaHeader";
import NoDataText from "../component/NoDataText";
import FtaInfoPie from "./FtaInfoPie";
import { VUE_SCROLL_OPTION } from "../../../ftaUtils/config";
import request from "../../../ftaUtils/http";
import baseUrl from "../../../ftaUtils/baseUrl";
import FtaTable from "../component/FtaTable";
import FtaInfoMap from "./FtaInfoMap";
import FtaBottomDateInfo from "../component/FtaBottomDateInfo";
import FtaTitle from "../component/FtaTitle";
import FtaInfoLine from "./FtaInfoLine";
import { getCookieKey } from "../../../ftaUtils/util";
import FtaInfoTap from "./FtaInfoTap.vue";
import pie from "@/views/topics/chinaTopics/components/pie";
export default {
  name: "FtaInfo",
  components: {
    FtaTitle,
    FtaInfoLine,
    FtaHeader,
    FtaTable,
    NoDataText,
    FtaInfoPie,
    FtaInfoMap,
    FtaBottomDateInfo,
    FtaInfoTap,
  },
  data() {
    return {
      openIcon: require("../../../assets/images/fta/icon11.png"),
      closeIcon: require("../../../assets/images/fta/icon10.png"),
      NEWeconomicsDisplay: true,
      loading: true,
      isShow1: false,
      code: "0",
      ponitShow: false,
      pointList: [
        { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
        { name: "Industrial Structure", code: 1, id: "#industry" },
        { name: "Economic Operation", code: 2, id: "#economic" },
        // { name: "Economic Development Trend", code: 3, id: "#development-of" },
        { name: "Investment Cost", code: 3, id: "#investment" },
        { name: "FTZ News", code: 4, id: "#News" },
      ],
      // 自贸区GDP增长趋势
      gdpList: [],

      // 自贸区新增企业增长趋势
      newEntCountList: [],

      // 自贸区吸引外资投资总额增长趋势
      fgnInvestList: [],

      // 自贸区进出口总额增长趋势
      tmxList: [],

      // 产业分布数据截止到
      structureLut: {},
      // 经济运行数据统计周期
      percentageLut: {},
      // 经济发展趋势数据截止到
      trendLut: {},
      // 投资决策数据截止到
      workLut: {},

      fullscreenLoading: false,
      waterIcon: require("../../../assets/images/fta/icon2.png"),
      electricIcon: require("../../../assets/images/fta/icon3.png"),
      iconPathIcon: require("../../../assets/images/fta/icon4.png"),
      iconPath: require("../../../assets/images/fta/icon1.png"),
      newsScrollFlag: true,
      ftaTableScroll: true,
      newsColumn: [
        { prop: "title", label: "Title", align: "left" },
        { prop: "catName", label: "Sector" },
        {
          width: "370px",
          prop: "published",
          label: "Date",
          color: "#3447FF",
        },
      ],
      icon: {
        iconUrl: require("@/assets/images/biaodian.svg"),
        iconSize: [18, 26],
        iconAnchor: [9, 26],
      },
      infoIntroduction: [],
      center: [121.373237, 31.273094],
      zoom: 5,
      path: [],
      showCity: true,
      mapListShow: [],
      scrollOption: VUE_SCROLL_OPTION,
      year: null,
      provinceId: "",
      isShow: false,
      titleName: "",
      titleCenter: [100.39769, 35.25945],
      city: "",
      cityList: [],
      cityListArr: [],
      province: null,
      provinceReport: "",
      proName: "",
      provinceList: [],
      arr: [],
      ftaGroupInfoList: [],
      norm: {},
      percentage: {},
      structureList: [],
      info: {},
      work: {},
      pie1: [],
      pie2: [],
      pie3: [],
      pie4: [],
      pie5: [],
      pie6: [],
      newsList: [],
      ftaGroupInfoColumn: [
        { prop: "name", label: "Company Name" },
        { prop: "type", label: "Company type" },
        { prop: "legalPerson", label: "Legal representative", width: "120" },
        { prop: "establishTime", label: "Date" },
        { prop: "registeredCapital", label: "Registered capital" },
        { prop: "openingStatus", label: "Opening status" },
        { prop: "address", label: "Address" },
        { prop: "industry", label: "Industry" },
        { prop: "businessScope", label: "Business scope" },
      ],
      pageConfig: {
        total: 10,
        page: 1,
        pageSize: 10,
      },
      searchToken:'',
      taxList: [],
      keyword: "policy",
      dataYear: {
        tmxTotalYear: "2020",
        taxTotalYear: "2020",
        fgnInvestTotalYear: "2020",
        tmxPrcYear: "2020",
        taxPrcYear: "2020",
        fgnInvestPrcYear: "2020",
      },
      jcentont: false,
    };
  },
  props: {
    downloadButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 计算显示多少个
    calculation() {
      if (
        this.dataYear.tmxTotalYear ||
        this.dataYear.taxTotalYear ||
        this.dataYear.fgnInvestTotalYear ||
        this.dataYear.tmxPrcYear ||
        this.dataYear.taxPrcYear ||
        this.dataYear.fgnInvestPrcYear ||
        this.taxList.length ||
        this.fgnInvestList.length ||
        this.newEntCountList.length ||
        this.tmxList.length
      ) {
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          { name: "Industrial Structure", code: 1, id: "#industry" },
          { name: "Economic Operation", code: 2, id: "#economic" },
          // { name: "Economic Development Trend", code: 3, id: "#development-of" },
          { name: "Investment Cost", code: 3, id: "#investment" },
          { name: "FTZ News", code: 4, id: "#News" },
        ];
        return true;
      } else {
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          { name: "Industrial Structure", code: 1, id: "#industry" },
          // { name: "Economic Operation", code: 2, id: "#economic" },
          // { name: "Economic Development Trend", code: 3, id: "#development-of" },
          { name: "Investment Cost", code: 2, id: "#investment" },
          { name: "FTZ News", code: 3, id: "#News" },
        ];
        return false;
      }
    },
  },
  methods: {
    changeNewecomic(e) {
      // console.log("在父组件",e);
      this.NEWeconomicsDisplay = e;
    },
    mouseleave() {
      this.isShow1 = false;
    },
    mousewheel() {
      this.isShow1 = true;
    },
    handlerMouseover() {
      this.ponitShow = false;
    },
    handlerClickId(item) {
      this.$emit("scrollId", item.code);
      // this.code = item.code;
    },
    // 接口：queryBy
    setDataQueryBy(data) {
      const {
        gdpList,
        newEntCountList,
        fgnInvestList,
        tmxList,

        ftaGroupInfoList,
        norm,
        percentage,
        work,
        info,
        structureList,

        structureLut,
        percentageLut,
        trendLut,
        workLut,
        taxList,
      } = data;
      // this.ftaGroupInfoList = ftaGroupInfoList
      this.ftaGroupInfoList =
        ftaGroupInfoList.map((el) => Object.assign(el, { close: true })) || [];
      this.norm = norm || {};
      this.work = work || {};
      this.structureLut = structureLut || {};
      this.percentageLut = percentageLut || {};
      this.trendLut = trendLut || {};
      this.workLut = workLut || {};
      this.taxList =
        taxList.filter((item) => item.val !== null).reverse() || {};

      this.gdpList = gdpList || {};
      this.newEntCountList =
        newEntCountList.filter((item) => item.val !== null).reverse() || {};
      this.fgnInvestList =
        fgnInvestList.filter((item) => item.val !== null).reverse() || {};
      this.tmxList =
        tmxList.filter((item) => item.val !== null).reverse() || {};
      this.setTabData();
      this.setDataInfo(info);
      this.setDataPie(percentage);
      this.setDataStructureList(structureList);
    },
    // 设置数据
    setTabData() {
      let arr = [
        this.taxList.length,
        this.fgnInvestList.length,
        this.newEntCountList.length,
        this.tmxList.length,
      ].filter((mp) => mp > 0);
      if (arr.length <= 1) {
        this.taxList = [];
        this.fgnInvestList = [];
        this.newEntCountList = [];
        this.tmxList = [];
      }
    },
    handleClick() {
      request("get", `${baseUrl.base_1}/ftaInfo/queryBy/${this.province}`)
        .then((res) => {
          this.setDataQueryBy(res.data);
          return request(
            "get",
            `${baseUrl.base_1}/ftaareainfo/queryAreaByFtaId/${this.province}`
          );
        })
        .then((res) => {
          this.NEWeconomicsDisplay = true;
          this.provinceReport = this.province;
          this.cityListArr = res.data;
          let provinceName = "";
          this.provinceList.forEach((item) => {
            if (item.id == this.province) {
              provinceName = item.val;
              this.proName = item.val;
            }
          });
          this.center = cityCenter[provinceName].center;
          this.zoom = cityCenter[provinceName].zoom;
          this.cityListArr.forEach((item) => {
            item.center = item.areaCoord.split(",");
          });
          this.pageConfig.page = 1
          this.getFtzNew();
        });
    },
    setDataPie(data) {
      if (!data) return;
      this.dataYear.tmxTotalYear = data.tmxTotalYear;
      this.dataYear.taxTotalYear = data.taxTotalYear;
      this.dataYear.fgnInvestTotalYear = data.fgnInvestTotalYear;
      this.dataYear.tmxPrcYear = data.tmxPrcYear;
      this.dataYear.taxPrcYear = data.taxPrcYear;
      this.dataYear.fgnInvestPrcYear = data.fgnInvestPrcYear;

      this.pie1 = [
        {
          name: this.norm.ftzName + "Total import and export",
          value: Number(data.tmx).toFixed(2),
        },
        {
          name: "Total import and export of other FTZs",
          value: (
            (Number(data.tmxTotal) * 100 - Number(data.tmx) * 100) /
            100
          ).toFixed(2),
        },
        {
          tmxTotalName: "National FTZs",
          tmxTotal: Number(data.tmxTotal).toFixed(2),
        },
      ];
      let pie1Perect =
        Number(data.tmx).toFixed(2) / Number(data.tmxTotal).toFixed(2);
      if (pie1Perect <= 0.05 || pie1Perect >= 0.95) {
        this.dataYear.tmxTotalYear = null;
      }
      this.pie2 = [
        {
          name: this.norm.ftzName + "Total Tax Revenue revenue",
          value: Number(data.tax).toFixed(2),
        },
        {
          name: "Tax revenue of other FTZs",
          value: (
            (Number(data.taxTotal) * 100 - Number(data.tax) * 100) /
            100
          ).toFixed(2),
        },
        {
          tmxTotalName: "National FTZs",
          tmxTotal: Number(data.taxTotal).toFixed(2),
        },
      ];
      let pie2Perect =
        Number(data.tax).toFixed(2) / Number(data.taxTotal).toFixed(2);
      if (pie2Perect <= 0.05 || pie2Perect >= 0.95) {
        this.dataYear.taxTotalYear = null;
      }
      this.pie3 = [
        {
          name: this.norm.ftzName + " Total FDI",
          value: Number(data.fgnInvest).toFixed(2),
        },
        {
          name: "FDI of other FTZs",
          value: (
            (Number(data.fgnInvestTotal) * 100 - Number(data.fgnInvest) * 100) /
            100
          ).toFixed(2),
        },
        {
          tmxTotalName: "National FTZs",
          tmxTotal: Number(data.fgnInvestTotal).toFixed(2),
        },
      ];
      let pie3Perect =
        Number(data.fgnInvest).toFixed(2) /
        Number(data.fgnInvestTotal).toFixed(2);
      if (pie3Perect <= 0.05 || pie3Perect >= 0.95) {
        this.dataYear.fgnInvestTotalYear = null;
      }
      this.pie4 = [
        {
          name: this.norm.ftzName + "Total import and export",
          value: Number(data.tmx).toFixed(2),
        },
        {
          name: "Import and export of other districts",
          value: (
            (Number(data.tmxPrc) * 100 - Number(data.tmx) * 100) /
            100
          ).toFixed(2),
        },
        {
          tmxTotalName: `${this.info.ftzPrc} ${
            ["Shanghai", "Beijing", "Tianjing", "Chongqing"].includes(
              this.info.ftzPrc
            )
              ? "municipality"
              : "province"
          }`,
          tmxTotal: Number(data.tmxPrc).toFixed(2),
        },
      ];
      let pie4Perect =
        Number(data.tmx).toFixed(2) / Number(data.tmxPrc).toFixed(2);
      if (pie4Perect <= 0.05 || pie4Perect >= 0.95) {
        this.dataYear.tmxPrcYear = null;
      }
      this.pie5 = [
        {
          name: this.norm.ftzName + "Total Tax Revenue revenue",
          value: Number(data.tax).toFixed(2),
        },
        {
          name: "Tax revenue of other districts",
          value: (
            (Number(data.taxPrc) * 100 - Number(data.tax) * 100) /
            100
          ).toFixed(2),
        },
        {
          tmxTotalName: `${this.info.ftzPrc} ${
            ["Shanghai", "Beijing", "Tianjing", "Chongqing"].includes(
              this.info.ftzPrc
            )
              ? "municipality"
              : "province"
          }`,
          tmxTotal: Number(data.taxPrc).toFixed(2),
        },
      ];
      let pie5Perect =
        Number(data.tax).toFixed(2) / Number(data.taxPrc).toFixed(2);
      if (pie5Perect <= 0.05 || pie5Perect >= 0.95) {
        this.dataYear.taxPrcYear = null;
      }

      this.pie6 = [
        {
          name: this.norm.ftzName + " Total FDI",
          value: Number(data.fgnInvest).toFixed(2),
        },
        {
          name: "FDI of other FTZs",
          value: (
            (Number(data.fgnInvestPrc) * 100 - Number(data.fgnInvest) * 100) /
            100
          ).toFixed(2),
        },
        {
          tmxTotalName: `${this.info.ftzPrc} ${
            ["Shanghai", "Beijing", "Tianjing", "Chongqing"].includes(
              this.info.ftzPrc
            )
              ? "municipality"
              : "province"
          }`,
          tmxTotal: Number(data.fgnInvestPrc).toFixed(2),
        },
      ];
      let pie6Perect =
        Number(data.fgnInvest).toFixed(2) /
        Number(data.fgnInvestPrc).toFixed(2);
      if (pie6Perect <= 0.05 || pie6Perect >= 0.95) {
        this.dataYear.fgnInvestPrcYear = null;
      }
      this.setModular();
    },
    setModular() {
      this.jcentont = false;
      const {
        tmxTotalYear,
        taxTotalYear,
        fgnInvestTotalYear,
        tmxPrcYear,
        taxPrcYear,
        fgnInvestPrcYear,
      } = this.dataYear;
      let arr = [
        { name: "tmxTotalYear", value: tmxTotalYear },
        { name: "taxTotalYear", value: taxTotalYear },
        { name: "fgnInvestTotalYear", value: fgnInvestTotalYear },
        { name: "tmxPrcYear", value: tmxPrcYear },
        { name: "taxPrcYear", value: taxPrcYear },
        { name: "fgnInvestPrcYear", value: fgnInvestPrcYear },
      ].filter((fl) => !!fl.value);
      if (arr.length == 1) {
        this.dataYear[arr[0].name] = null;
      } else if (arr.length == 4) {
        this.dataYear[arr[3].name] = null;
      } else if (arr.length == 2) {
        this.jcentont = true;
      } else if (arr.length == 5) {
        this.jcentont = true;
      }
    },
    setDataInfo(data) {
      if (!data) return;
      const { manageOrg, indsStrategy } = data;
      if (manageOrg && manageOrg.length) {
        data.manageOrg = manageOrg.split("&"); // 管理机构 中文用 英文用 &  分割
      }

      if (indsStrategy && indsStrategy.length) {
        data.indsStrategy = indsStrategy.split(","); // 重点产业  中文用  、 英文用 ,  分割
      }

      this.info = data;
      this.infoIntroduction = data.introduction.split("&");
    },
    setDataStructureList(data) {
      if (!data) return;
      if (data && data.length) {
        const dataObj = data[0];

        this.structureList = [
          {
            label: "Primary industry",
            value: dataObj.oneInds,
          },
          {
            label: "Secondary industry",
            value: dataObj.twoInds,
          },
          {
            label: "Tertiary industry",
            value: dataObj.threeInds,
          },
        ];
      } else {
        this.structureList = [];
      }
    },
    pageInit() {
      const TS02b1f2d3 = getCookieKey("TS02b1f2d3");
      this.$store.commit("ftaToken", TS02b1f2d3);

      const keyword = "policy"; //FTZ info  // 自贸区信息

      // 获取省市下拉框信息
      request("get", `${baseUrl.base_1}/ftaInfo/queryProvince`)
        .then((res) => {
          if (this.$route.query.province) {
            const data = res.data;
            this.province = this.$route.query.province;
            this.provinceList = data;
          } else {
            const data = res.data;
            this.province = data[0].id;
            this.provinceList = data;
          }
          this.pageConfig.page = 1
          this.getFtzNew();
          // 自贸区信息
          return request(
            "get",
            `${baseUrl.base_1}/ftaInfo/queryBy/${this.province}`
          );
        })
        .then((res) => {
          this.setDataQueryBy(res.data);
          return request(
            "get",
            `${baseUrl.base_1}/ftaInfo/queryAreaByFtaId/${this.province}`
          );
        })
        .then((res) => {
          this.provinceReport = this.province;
          this.cityListArr = res.data;

          // 画出省份
          let provinceName = "";
          this.provinceList.forEach((item) => {
            if (item.id == this.province) {
              provinceName = item.val;
              this.proName = item.val;
            }
          });
          this.center = cityCenter[provinceName].center;
          this.zoom = cityCenter[provinceName].zoom;

          this.cityListArr.forEach((item) => {
            item.center = item.areaCoord.split(",");
          });
        });
      //   新闻
      // request("get", `${baseUrl.base_3}/api/tags/FTZ?page=1`)
      //   .then((res) => {
      //     this.pageConfig.total = res.data.total;
      //     let list = res.data.content;
      //     list.forEach((item, index) => {
      //       item.num = index + 1;
      //       // item.keyword = item.catName
      //       item.tags.forEach((ele) => {
      //         item.keyword = item.keyword
      //           ? item.keyword + "," + ele.name
      //           : ele.name;
      //       });
      //     });
      //     this.newsList = list;
      //   })
      //   .catch((err) => {
      //     console.log(err, "err");
      //   });
      // this.$http({
      //   url:
      //     'https://recommend.imsilkroad.com/recommend/rest/2/0/0/0/0/0/0/' +
      //     keyword +
      //     '/0/0/0',
      //   method: 'get'
      // }).then((res) => {
      //   console.log('res',res)
      //   const { results } = res.body
      //   if (results && results.length) {
      //     results.forEach(item=>{
      //       item.keyword = keyword
      //     })
      //     this.newsList = results
      //   }
      // })
    },
    // 获取自贸区新闻资讯
    getFtzNew() {
      let key = this.provinceList.find((el) => el.id === this.province);
      const province = key.val
      let param = {
        // aggs:[{d:'3',v:[],k:{columnItem:"published",format:"yyyy",interval:"year",name:"时间",types:"terms"}},
        //       {d:'0',v:[],k:{columnItem:"one_level_org.keyword",name:"机构",types:"terms"}},
        //       {d:'0',v:[],k:{columnItem:"key_words.keyword",exclude:"中文摘要|原文标题",include:"(.){3,10}",name:"关键词",types:"terms"}},
        //       {d:'0',v:[],k:{columnItem:"industry.keyword",name:"行业",types:"terms"}},
        //       {d:'0',v:[],k:{columnItem:"one_level_province.keyword",name:"中国省份",types:"terms"}}
        //     ],
        // featureWeights:[
        //   {k: "16", v: "2"},
        //   {k: "19", v: "1"},
        //   {k: "18", v: "1.3"},
        //   {k: "17", v: "1.5"},
        //   {k: "20", v: "2"}
        // ],    
        hieghtQueryBean:[
          {column:"[\"title.smart\"]",midd:0,type:0,value:province},
          {column: "[\"content.smart\"]",midd:0,type:0,value:province},
        ],
        current:0,
        docTypeList:['All'],
        isAggs:1,
        isExplain:false,
        isFilter:0,
        isRecovery:true,
        kw:"",
        pageNo:this.pageConfig.page,
        pageSize:10,
        psn:10005,
        templateId:"3",
        token:this.searchToken
      }          
      this.$axios.post(`${baseUrl.base_2}/kgapi/search/simplekw`,param)
        .then((res) => {
          this.pageConfig.total = res.data.data.rsCount;
          this.searchToken = res.data.data.token
          let data = (res.data.data.rsData || []).map( ele =>{
            return {
              title:ele.sourceAsMap.title,
              catName:ele.sourceAsMap.catName,
              published:Number(ele.sourceAsMap.published),
              id:ele.sourceAsMap.contentid.split("_")[1]
            }
          });
          this.newsList = data;
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    // 改变分页
    changePage(e) {
      this.pageConfig.page = e.page
      this.getFtzNew();
    },
    doScroll(ref, flag) {
      const table = this.$refs[ref].$refs.table;
      const divData = table.bodyWrapper;
      divData.onmouseenter = () => {
        this[flag] = false;
      };
      divData.onmouseleave = () => {
        this[flag] = true;
      };
    },
    dataURLtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, { type: mime });
    },
    generateFile(selector) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          window.pageYoffset = 0;
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          html2canvas(selector, { scale: 1 })
            .then((canvas) => {
              resolve(this.dataURLtoFile(canvas.toDataURL("image/png", 1.0)));
            })
            .catch((err) => {
              reject(err);
            });
        });
      }, 50);
    },
    async downloadReport() {
      try {
        // this.fullscreenLoading = true;
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const arr = [
          document.getElementById("box"),
          document.getElementById("box1"),
          document.getElementById("box2"),
          document.getElementById("box3"),
          document.getElementById("box4"),
          document.getElementById("box5"),
          document.getElementById("box6"),
        ].map((item) => (item ? this.generateFile(item) : ""));
        const [file, file1, file2, file3, file4, file5, file6] =
          await Promise.all(arr);
        const fd = new FormData();
        const base64 =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA5CAYAAACF8yP/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAABRSURBVGhD7c8BAQAACMMg+5e+QRgNuIFKK0orSitKK0orSitKK0orSitKK0orSitKK0orSitKK0orSitKK0orSitKK0orSitKK0orSitKG7YHB/wg18hWRYIAAAAASUVORK5CYII=";
        const fil = this.dataURLtoFile(base64);
        fd.append("ftzId", this.provinceReport);
        fd.append("files", file);
        file1 ? fd.append("files", file1) : fd.append("files", fil);
        file2 ? fd.append("files", file2) : fd.append("files", fil);
        file3 ? fd.append("files", file3) : fd.append("files", fil);
        file4 ? fd.append("files", file4) : fd.append("files", fil);
        file5 ? fd.append("files", file5) : fd.append("files", fil);
        file6 ? fd.append("files", file6) : fd.append("files", fil);

        request("post", `${baseUrl.base_1}/ftaInfo/downloadReport`, fd).then(
          (res) => {
            let blob = new Blob([res.data], { type: "application/zip" });
            let url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Report.zip"; // 重命名文件
            link.click();
            window.URL.revokeObjectURL(url); // 释放内存
            // this.fullscreenLoading = false;
            loading.close();
          }
        );
      } catch (error) {}
    },
  },
  mounted() {
    this.pageInit();
    this.doScroll("newsTable", "newsScrollFlag");
    // this.doScroll('ftaTable', 'ftaTableScroll')
    this.$eventBus.$on("changeData", (data) => {
      this.ponitShow = data.ponitShow;
      this.code = data.code;
    });
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>

<style src="../fta.css"  scoped></style>
<style lang="less"  src="./FtaInfo.less"  scoped></style>
<style scoped lang="less">
.point {
  position: fixed;
  right: 5%;
  top: 29.5%;
  background: #ffffff;
  border: 1px solid #c9e4ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
  border-radius: 0 0 5px 5px;
  width: 123px;
  z-index: 1000;
  padding: 17px 13px 6px;

  &::before {
    content: "";
    background-image: linear-gradient(180deg, #51c9ff 0%, #89e5ff 100%);
    border-radius: 5px 5px 0 0;
    width: 123px;
    height: 8px;
    position: absolute;
    top: -8px;
    left: -1px;
  }

  > div {
    border-left: 1px solid #d7d7d7;

    > div {
      opacity: 0.3;
      // font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #000000;
      letter-spacing: -0.24px;
      font-weight: 400;
      text-indent: 9px;
      overflow: hidden;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90px;
      margin-bottom: 13px;
    }

    .active-scroll {
      // font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #208eff;
      letter-spacing: -0.24px;
      font-weight: 400;
      opacity: 1;
      border-left: 1px solid #2291fe;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90px;
    }
  }
}
.ti-2em {
  font-size: 12px;
  // font-weight: 500;
}
.item {
  font-size: 12px;
  // font-weight: 500;
}
.item span {
  font-size: 12px;
  // font-weight: 400;\
}
// .title p{
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   position: relative;
// }
</style>
